module.exports = __webpack_public_path__ + "d5d6ae20f5c7296c10283e7456944e53.png";